const scrollLock = (lock = false) => {
  //compensate for scrollbarwidth so page doesn't jump when we hide the scroll bar
  let scrollBarWidth = window.innerWidth - document.body.offsetWidth

  const header = document.getElementById('shopify-section-header')

  if (lock) {
    document.body.classList.add('no-scroll')
    document.body.style.paddingRight = scrollBarWidth + 'px'
    header.style.paddingRight = scrollBarWidth + 'px'
  } else {
    document.body.classList.remove('no-scroll')
    document.body.style.paddingRight = '0px'
    header.style.paddingRight = '0px'
  }
}

let escCallBack = () => {
  //console.log('ESC button clicked but no callback function was passed');
}

let escFunction = (event) => {
  if (event.key === 'Escape') {
    escCallBack()
    window.removeEventListener('keydown', escFunction)
  }
}

// this enables and disables listening for an ESC button
const escListener = (enable = false, callbackFunction) => {
  // we pass a callback function that executes when we hit ESC
  if (callbackFunction) {
    escCallBack = callbackFunction
  }

  if (enable) {
    window.addEventListener('keydown', escFunction)
  }

  if (!enable) {
    window.removeEventListener('keydown', escFunction)
  }
}

// debounce

function debounce(fn, wait) {
  var _this = this

  var t
  return function () {
    for (
      var _len = arguments.length, args = new Array(_len), _key = 0;
      _key < _len;
      _key++
    ) {
      args[_key] = arguments[_key]
    }

    clearTimeout(t)
    t = setTimeout(function () {
      return fn.apply(_this, args)
    }, wait)
  }
}

// scroll

const scrollTo = (element) => {
  Math.easeInOutQuad = function (t, b, c, d) {
    t /= d / 2
    if (t < 1) return (c / 2) * t * t + b
    t--
    return (-c / 2) * (t * (t - 2) - 1) + b
  }

  const to = element.offsetTop - 150
  const duration = 200
  const start = window.scrollY
  const change = to - start
  const increment = 5
  let currentTime = 0
  const animateScroll = () => {
    currentTime += increment

    const val = Math.easeInOutQuad(currentTime, start, change, duration)

    window.scrollTo(0, val)

    if (currentTime < duration) {
      setTimeout(animateScroll, increment)
    }
  }

  animateScroll()
}

document.querySelectorAll('.local-scroll').forEach((el) => {
  el.addEventListener('click', (e) => {
    e.preventDefault()
    e.stopPropagation()
    const id = e.target.getAttribute('href')
    const scrollToElement = document.querySelector(id)
    scrollTo(scrollToElement)
  })
})

// cookies
const setCookie = (cname, cvalue, exdays) => {
  const d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  let expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
}

const getCookie = (cname) => {
  let name = cname + '='
  let decodedCookie = decodeURIComponent(document.cookie)
  let ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) == ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

export { scrollLock, escListener, debounce, scrollTo, setCookie, getCookie }
